import {DataListModel} from '../interface';
import {GalleryModel} from './galleryModel';

export class GalleriesModel extends DataListModel {
  items: GalleryModel[] = [];
}
